export default __webpack_public_path__ + "static/media/logo_Qibo-10.9417937b.svg";